import { useEffect, useState } from "react";
import { findEntityData, findSectionData } from "../../api/apiService";

const WhatMakesUsSpecial = () => {
    const [section1, setSection1] = useState()
    const findData = async () => {
        const res = await findEntityData('sss_home_wmus')
        setSection1(res?.data?.[0])
    }

    useEffect(() => {
        findData()
    }, [])
    return (
        <div>
            <section className="special py-16 px-4 overflow-hidden">
                <div className="container mx-auto text-center">
                    <h2 className="text-2xl md:text-4xl font-bold text-[#F37934] mb-6 leading-snug"
                        data-aos="fade-right"
                        data-aos-duration="800"
                        data-aos-easing="ease-out"
                        data-aos-delay="400"
                        data-aos-anchor-placement="top-bottom" >
                        {section1?.heading}
                    </h2>
                    <p className="max-w-sm mx-auto mb-8 text-[16px] font-quicksand font-normal leading-relaxed"
                        data-aos="fade-left"
                        data-aos-duration="800"
                        data-aos-delay="600" data-aos-anchor-placement="top-bottom" >
                        {section1?.content}
                    </p>
                    <div className=" space-y-6">
                        {/* Top centered box */}
                        <div className="flex justify-center"
                            data-aos="fade-right"
                            data-aos-duration="900"
                            data-aos-delay="800" data-aos-anchor-placement="top-bottom" >
                            <div className="px-4 py-2 rounded-full border border-white 
                    bg-gradient-to-r from-[#F0F0E5] via-white to-[#F0F0E5] 
                    w-fit max-w-md text-center">
                                <p className="font-semibold">{section1?.data?.[0]?.item}</p>
                            </div>
                        </div>
                        <div className="flex flex-wrap justify-center gap-3 !mt-[13px] sm:mt-0"
                            data-aos="fade-left"
                            data-aos-duration="1000"
                            data-aos-delay="1000" data-aos-anchor-placement="top-bottom" >
                            {section1?.data?.map((item, i) => (
                                <div>
                                    {i !== 0 &&
                                        <div key={i} className="px-4 py-2 rounded-full border border-white bg-gradient-to-r from-[#F0F0E5] via-white to-[#F0F0E5] 
                    w-fit">
                                            <p className="font-semibold">{item?.item}</p>
                                        </div>
                                    }
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </section>
        </div>
    )
}

export default WhatMakesUsSpecial
